import { render, staticRenderFns } from "./add.modal.vue?vue&type=template&id=2d7dd4ae&scoped=true&"
import script from "./add.modal.vue?vue&type=script&lang=js&"
export * from "./add.modal.vue?vue&type=script&lang=js&"
import style0 from "./add.modal.vue?vue&type=style&index=0&id=2d7dd4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7dd4ae",
  null
  
)

export default component.exports